<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeCallBack">
            <el-form label-width="100px" :model="form" :rules="rules" ref="ruleform">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="幼儿园名称" prop="SchoolName" required>
                            <el-input v-model="form.SchoolName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="园长名称" prop="PrincipalName" required>
                            <el-input v-model="form.PrincipalName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <areaSelect ref="area" :value="address" required label-width="100px"></areaSelect>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="详细地址" prop="Address" required>
                            <el-input v-model="form.Address"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="所属代理商" prop="AgentId" required style="width:100%">
                            <el-select v-model="form.AgentId" placeholder="请选择或搜索" :disabled="!opts.isFormEidt" v-show="agentVisible" filterable style="width:100%">
                                <el-option v-for="item in AgentList" :label="item.Customer" :value="item.Id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="园长电话" prop="PhoneNo" required>
                            <el-input v-model="form.PhoneNo"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="园所电话" prop="AddPhoneNo" required>
                            <el-input v-model="form.AddPhoneNo"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Email">
                            <el-input v-model="form.Email"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="QQ2">
                            <el-input v-model="form.QQ"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="微信">
                            <el-input v-model="form.Weixin"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="数据类型" required>
                            <el-radio-group v-model="form.DataType">
                                <el-radio :label="0">测试</el-radio>
                                <el-radio :label="1">正式</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" v-show="SubjectList.length">
                        <el-form-item label="项目类型" required>
                            <el-checkbox-group v-model="ProjectType" @change="changeProjectType">
                                <el-checkbox v-for="item in SubjectList" :disabled="!opts.isFormEidt" :label="item.ProjectTypeId">{{item.ProjectTypeName}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" v-show="PolicyList.length">
                        <el-form-item label="政策类型">
                            <el-checkbox-group v-model="PolicyType">
                                <el-checkbox v-for="item in PolicyList" :label="item.PolicyTypeId">{{item.PolicyTypeName}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="addfn" v-if="isAdd">确 定</el-button>
                <el-button type="primary" @click="updatefn" v-if="isUpdate">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import $http from "$http";
import NProgress from "nprogress";
import { cloneDeep, util, isCorrectVal, isDate, lg } from "utils";

//组件
import areaSelect from "area-select";

export default {
  components: {
    areaSelect
  },
  props: {},
  data() {
    return {
      SubjectList: [], //项目类型
      isAdd: false,
      isUpdate: false,
      isReadonly: false,
      dialogVisible: false,
      agentVisible: true,
      opts: this.getSettings(),
      address: {
        Provinces_Id: "",
        City_Id: "",
        Area_Id: ""
      },
      ProjectType: [], //项目类型
      Myshort: [],
      PolicyList: [],
      PolicyType: [],
      MyPolicy: [],
      form: this.initFormData(),
      /*表单验证规则 */
      rules: {
        SchoolName: [{ required: true, message: "请输入园所名称", trigger: "blur" }],
        PrincipalName: [
          { required: true, message: "请输入园长名称", trigger: "blur" }
        ],
        Address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        AgentId: [{ required: true, message: "请选择代理商" }],
        PhoneNo: [{ validator: util.elCheckPhone, trigger: "blur" }],
        AddPhoneNo: [{ validator: util.elCheckPhone, trigger: "blur" }]
      }
    };
  },
  methods: {
    getSettings() {
      return cloneDeep({
        Id: "",
        isAdd: false,
        isUpdate: false,
        isFormEidt: true,
        upDateDataUrl: "api/School/ZqwPlatform_UpdateSchool",
        loadDataUrl: "api/School/ZqwPlatform_GetSchoolModel",
        isReadonly: false
      });
    },
    initFormData() {
      return cloneDeep({
        AgentId: "",
        SchoolName: "",
        LongCode: "0.0",
        LatCode: "0.0",
        Address: "", //详细地址
        PhoneNo: "", //园长电话
        ProvId: "",
        CityId: "",
        AreaId: "",
        SchoolId: "",
        ProjectType: "",
        PrincipalName: "", //园长
        AddPhoneNo: "", //园所电话
        Email: "",
        QQ: "",
        DataType: 0,
        Weixin: "", //微信
        PolicyType: ""
      });
    },
    show(options) {
      let opts = $.extend({}, this.getSettings(), options);
      this.isUpdate = opts.isUpdate;
      this.isAdd = opts.isAdd;
      this.isReadonly = opts.isReadonly;
      this.opts = opts;
      if (this.isReadonly || this.isUpdate) {
        this.loadData(opts);
        this.dialogVisible = true;
        return;
      }
      this.dialogVisible = true;
    },
    closeCallBack() {
      this.Myshort = [];
      this.resetForm();
      this.MyPolicy = [];
    },
    changeProjectType(item) {
      console.log(item);
      if (item.indexOf(2) !== -1) {
        console.log(4964);
        this.req_getProjectType2();
      } else {
        this.MyPolicy = [];
        this.PolicyList = [];
      }
    },
    loadData(opts, callback) {
      let Params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        Id: opts.Id
      };
      let $msg = this.$message({
        message: "正在获取数据，请稍后...",
        duration: 0
      });

      //ZqwPlatform_ModifySchool
      $http.get(opts.loadDataUrl, Params).then(res => {
        $msg.close();
        util.doResult(this, res, () => {
          let { Data } = res.data;
          this.address.Provinces_Id = Data.Provinces_id;
          this.address.City_Id = Data.City_id;
          this.address.Area_Id = Data.Area_id;
          this.form.AgentId = Data.AgentId;
          this.form.AddPhoneNo = Data.Tel;
          this.form.Weixin = Data.Weixin;
          this.form.QQ = Data.QQ;
          this.form.Email = Data.Email;
          this.form.SchoolName = Data.SchoolName;
          this.form.Address = Data.Address;
          this.form.PrincipalName = Data.PrincipalName;
          this.form.PhoneNo = Data.PhoneNo;
          this.form.Id = Data.SchoolId;
          this.form.SchoolId = Data.SchoolId;
          this.form.DataType = Data.DataType;
          if (Data.ProjectTypes !== "") {
            let a = Data.ProjectTypes.split(",");
            for (var i = 0; i < a.length; i++) {
              this.Myshort.push(parseInt(a[i]));
            }
            if (this.Myshort.indexOf(2) != -1) {
              this.req_getProjectType2();
              if (Data.PolicyTypes !== "") {
                let a = Data.PolicyTypes.split(",");
                for (var i = 0; i < a.length; i++) {
                  this.MyPolicy.push(parseInt(a[i]));
                }
              }
            }
          }
          if (typeof callback == "function") {
            callback();
          }
        });
      });
    },
    addfn() {
      let validateArea = this.$refs.area.validate();
      this.$refs["ruleform"].validate(valid => {
        if (valid && !(validateArea == false)) {
          let addressObj = this.$refs.area.validate();
          this.form.ProvId = addressObj.Provinces_Id;
          this.form.CityId = addressObj.City_Id;
          this.form.AreaId = addressObj.Area_Id;
          this.form.ProjectType = this.ProjectType.join(",");
          this.form.PolicyType = this.PolicyType.join(",");
          if (this.SubjectList.length > 0) {
            if ($.trim(this.form.ProjectType).length == 0) {
              this.$notify({
                title: "警告",
                message: "请选择项目类型",
                type: "warning"
              });
              return;
            }
          }
          $http
            .post("api/School/ZqwPlatform_AddSchool", this.form)
            .then(res => {
              util.doResult(this, res, () => {
                this.$notify({
                  title: "成功",
                  message: "添加成功",
                  type: "success"
                });
                this.dialogVisible = false; //关闭窗体
                this.$emit("refreshList"); // 向上派发 toggle事件
              });
            });
        } else {
          return false;
        }
      });
    },
    updatefn() {
      let validateArea = this.$refs.area.validate();
      this.$refs["ruleform"].validate(valid => {
        if (valid && !(validateArea == false)) {
          let addressObj = this.$refs.area.validate();
          this.form.ProvId = addressObj.Provinces_Id;
          this.form.CityId = addressObj.City_Id;
          this.form.AreaId = addressObj.Area_Id;
          this.form.ProjectType = this.ProjectType.join(",");
          this.form.PolicyType = this.PolicyType.join(",");
          //console.log(this.PolicyType)
          $http.post(this.opts.upDateDataUrl, this.form).then(res => {
            util.doResult(this, res, () => {
              this.$notify({
                title: "成功",
                message: "更新成功",
                type: "success"
              });
              this.dialogVisible = false; //关闭窗体
              this.$emit("refreshList"); // 向上派发 toggle事件
            });
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      for (let key in this.address) {
        if (Object.prototype.hasOwnProperty.call(this.address, key)) {
          //过滤
          if (this.address[key] != "") {
            this.address[key] = "";
          }
        }
      }
      this.form = this.initFormData();
      this.$refs.area.clearResultValue();
    },
    req_getProjectType(callback) {
      if (this.form.AgentId !== "") {
        let params = {
          Sid: this.$store.state.sysSid,
          Session: this.$store.state.sysSession,
          AgentId: this.form.AgentId
        };
        $http.get("api/School/GetProjectByAgentId", params).then(res => {
          util.doResult(this, res, () => {
            this.SubjectList = res.data.Data;
            this.ProjectType = this.Myshort;

            if (typeof callback == "function") {
              callback();
            }
          });
        });
      }
    },
    req_getProjectType2(callback) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        AgentId: this.form.AgentId
      };
      $http.get("api/School/GetPolicyTypeByAgentId", params).then(res => {
        util.doResult(this, res, () => {
          this.PolicyList = res.data.Data;
          this.PolicyType = this.MyPolicy;
          if (typeof callback == "function") {
            callback();
          }
        });
      });
    }
  },
  watch: {
    "form.AgentId"() {
      this.$nextTick(function() {
        this.SubjectList = [];
        this.ProjectType = [];
        this.PolicyList = [];
        this.PolicyType = [];
        this.req_getProjectType();
      });
    }
  },
  computed: {
    AgentList() {
      return this.$store.state.AgentList;
    }
  },
  mounted() {
    this.$store.dispatch("getAgentList");
  }
};
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// schoolDetails.vue?12335017